import { Repeat } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface Props {
  className?: string
}

const RecurringBadge = ({ className }: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Repeat
          className={className ?? 'h-3 w-3 shrink-0'}
          aria-hidden="true"
          data-testid="recurring-badge"
        />
      </TooltipTrigger>
      <TooltipContent color="secondary">Teil einer wiederkehrenden Serie</TooltipContent>
    </Tooltip>
  )
}

export default RecurringBadge
